import { required } from '@bpba/form-components';
import {
  DNI_MAX_LENGTH,
  DNI_MIN_LENGTH,
  DNI_PROCEDURE_LENGTH,
  DNI_PROCEDURE_LENGTH_MESSAGE,
  EMAIL_PATTERN,
  INPUT_INVALID_FORMAT_MESSAGE,
  INTEGER_NUMBER_FORMAT,
} from '../constants/form';

const dniValidation = {
  required,
  pattern: {
    message: INPUT_INVALID_FORMAT_MESSAGE,
    value: INTEGER_NUMBER_FORMAT,
  },
  minLength: {
    message: `Debe tener al menos ${DNI_MIN_LENGTH} dígitos`,
    value: DNI_MIN_LENGTH,
  },
  maxLength: {
    message: `Debe tener hasta ${DNI_MAX_LENGTH} dígitos`,
    value: DNI_MAX_LENGTH,
  },
};

const emailValidation = {
  required,
  pattern: {
    message: INPUT_INVALID_FORMAT_MESSAGE,
    value: EMAIL_PATTERN,
  },
};

const procedureValidation = {
  required,
  pattern: {
    message: INPUT_INVALID_FORMAT_MESSAGE,
    value: INTEGER_NUMBER_FORMAT,
  },
  minLength: {
    message: DNI_PROCEDURE_LENGTH_MESSAGE,
    value: DNI_PROCEDURE_LENGTH,
  },
  maxLength: {
    message: DNI_PROCEDURE_LENGTH_MESSAGE,
    value: DNI_PROCEDURE_LENGTH,
  },
};

export const SignUpHomeRules = {
  rules: {
    email: emailValidation,
    documentNumber: dniValidation,
    procedureNumber: procedureValidation,
    gender: { required },
  },
};
